export default "__VITE_ASSET__DfPtZNf1__"